export default __webpack_public_path__ + "static/media/AppDashboard.9c1eca44.png";